import React from "react";
import { ContractConfig } from "types";

export type NftContractContextValue = ContractConfig | undefined;

const NftContractContext =
  React.createContext<NftContractContextValue>(undefined);

export default NftContractContext;
